import axios from "axios";
export const getDashboardAnalytics = (searchState: any) => {
  return axios.get(
    `/admin-dashboard-analytics?${searchState.startDate ? `startDate=${searchState.startDate}` : ""}${
      searchState?.endDate ? `&endDate=${searchState?.endDate}` : ""
    }${searchState.funnelDate ? `&funnelDate=${searchState.funnelDate}` : ""}${searchState.countries ? `&countries=${searchState.countries?.join(",")}` : ""}`,
  );
};

export const recordAnalyticsEvent = (data: {
  type: "visit" | "app_click";
  platform: "web" | "ios" | "android";
  visitorId: string;
  country: string;
}) => {
  return axios.post("/admin-analytics-event", data);
};
